/**
 * Featured projects — single source of truth shared by LandingPage.vue
 * and the ChatAgent's inline project cards.
 * Mirrored into shared/knowledge.cjs for the server-side agent; keep both in sync.
 */
export const PROJECTS = [
  {
    name: 'Ritual Kitchen',
    icon: 'fas fa-utensils',
    color: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
    role: 'Founder & Builder',
    description: 'Private chef booking platform connecting diners with culinary experiences.',
    stack: ['Next.js', 'Supabase', 'Stripe'],
    url: 'https://ritual.kitchen',
    isActive: true,
  },
  {
    name: 'Ritual Ops',
    icon: 'fas fa-people-group',
    color: 'linear-gradient(135deg, #0ea5e9, #0284c7)',
    role: 'Founder & Builder',
    description: 'Work, reimagined. Empower teams with clarity and rhythm.',
    stack: ['Vue', 'Node.js'],
    url: 'https://www.ritualops.com/workforce',
    isActive: true,
  },
  {
    name: 'Wisconsin Workways',
    icon: 'fas fa-map-location-dot',
    color: 'linear-gradient(135deg, #1e6b9c, #267a55)',
    role: 'Founder & Builder',
    description: 'Interactive map and AI assistant for Wisconsin jobs, local economics, and the transit routes that connect people to work.',
    stack: ['Next.js', 'Mapbox', 'Gemini'],
    url: 'https://wisco-data.vercel.app/',
    isActive: true,
  },
  {
    name: 'Thryve Connect',
    icon: 'fas fa-people-arrows',
    color: 'linear-gradient(135deg, #ec4899, #be185d)',
    role: 'Founder & Builder',
    description: 'Connecting communities through seamless digital experiences.',
    stack: ['Vue', 'Node.js'],
    url: 'https://thryveconnect.com',
    isActive: true,
  },
];
